
import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import {
  RESET_PASSWORD, RESET_PASSWORD_SUCCESS,
} from "./actionTypes";

import {
  resetPasswordFail, resetPasswordSuccess,
} from "./actions";

import {
  resetPasswordUrl
} from "../../../helpers/fakebackend_helper";

function* onResetPassword({payload: {token, password, history}}) {
  try {
    const response = yield call(resetPasswordUrl, token, {
      password: password
    });
    yield put(resetPasswordSuccess(response.message));
    setTimeout(()=> {
      history('/login');
    }, 4000);
  } catch (error) {
    yield put(resetPasswordFail(error.response.data.message));
  }
}

function* resetPasswordSaga() {
  yield takeEvery(RESET_PASSWORD, onResetPassword);
}

export default resetPasswordSaga;
